import React from 'react';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import StickyAudioPlayer from './components/StickyAudioPlayer';

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col relative bg-grunge-black">
      {/* Global Background Layer */}
      <div className="fixed inset-0 z-0 bg-sunflower bg-cover bg-center bg-no-repeat bg-fixed opacity-20 mix-blend-luminosity"></div>
      
      {/* Content wrapper to sit above background */}
      <div className="relative z-10 flex flex-col flex-grow">
        <Navigation />
        <main className="flex-grow">
          {children}
        </main>
        <Footer />
        <StickyAudioPlayer />
      </div>
    </div>
  );
}